<template>
  <div class="actions">
    <div v-if="showLaunch" class="launch-row">
      <span class="launch-label">Amount</span>
      <input
        class="launch-input"
        v-model="launchAmount"
        inputmode="numeric"
        placeholder="1000000"
        @input="launchAmount = normAmount(launchAmount)"
      />
    </div>

    <button
      v-if="showLaunch"
      class="btn primary"
      type="button"
      :disabled="!canLaunch"
      @click="onLaunch"
    >
      Launch
    </button>

    <button
      class="btn"
      type="button"
      :disabled="!entity"
      @click="$emit('copy', entity)"
    >
      Copy
    </button>

    <button
      v-if="isLocal"
      class="btn danger"
      type="button"
      :disabled="!entity"
      @click="$emit('delete', entity)"
    >
      Delete
    </button>

    <p v-if="!entity" class="hint">Select a mint or coin</p>
    <p v-else-if="!devWallet" class="hint">Set dev wallet to enable Launch / Copy</p>
    <p v-else-if="!devWalletHasBalance" class="hint">Dev wallet has 0</p>
  </div>
</template>

<script setup>
// Vue не разрешает два <script setup>. Удали блок выше с emit-пояснениями.
// Оставь этот единственный блок:

import { computed, ref } from 'vue'
import { normAmount } from './utils'

const props = defineProps({
  entity: { type: Object, default: null },
  isLocal: { type: Boolean, default: false },
  isLaunched: { type: Boolean, default: false },
  devWallet: { type: String, default: '' },
  devWalletOptions: { type: Array, default: () => [] },
})

const emit = defineEmits(['launch', 'copy', 'delete'])

const launchAmount = ref('1000000')

const devWalletObj = computed(() => {
  const pk = props.devWallet
  if (!pk) return null
  return props.devWalletOptions.find(w => w && (w.public_key === pk || w.publicKey === pk)) || null
})

const devWalletHasBalance = computed(() => {
  const w = devWalletObj.value
  if (!w) return false
  const lamports = Number(w.lamports || 0)
  return Number.isFinite(lamports) && lamports > 0
})

const showLaunch = computed(() => {
  if (!props.entity) return false
  if (props.isLaunched) return false
  return !!props.devWallet && devWalletHasBalance.value
})

const canLaunch = computed(() => {
  if (!props.entity) return false
  if (props.isLaunched) return false
  if (!props.devWallet) return false
  if (!devWalletHasBalance.value) return false
  return true
})

function onLaunch() {
  if (!canLaunch.value) return
  const amount = normAmount(launchAmount.value)
  if (!amount || amount === '0') return
  emit('launch', { entity: props.entity, amount })
}
</script>

<style scoped>
.actions{
  display:flex;
  flex-direction:column;
  gap:10px;
}

.launch-row{
  display:flex;
  align-items:center;
  gap:8px;
}

.launch-label{
  font-size:11px;
  color:#9ca3af;
  min-width:52px;
}

.launch-input{
  flex:1;
  padding:6px 8px;
  border-radius:6px;
  border:1px solid #333;
  background:#0b0b0b;
  color:#e5e7eb;
  font-size:12px;
}

.btn{
  width:100%;
  padding:6px 10px;
  border-radius:6px;
  border:1px solid #333;
  background:#0b0b0b;
  color:#e5e7eb;
  font-size:13px;
  cursor:pointer;
  text-align:center;
}

.btn.primary{ background:#2563eb; border-color:#2563eb; }
.btn.danger{ background:#3f1a1a; border-color:#7f1d1d; color:#fecaca; }

.btn:disabled{ opacity:0.5; cursor:default; }
.btn:not(:disabled):hover{ background:#111827; }

.hint{
  margin-top:2px;
  font-size:11px;
  color:#6b7280;
}
</style>
